module.exports = __webpack_public_path__ + "static/media/glyph-left.67557dd9.svg";